<style lang="scss" scoped>
@import "$vars";
.modal-container {
  >* {
    margin: 0 -14px
  }
  .modal-header {
    .close-block {
      height: 15px;
    }
    .consultation-type {
      display: flex;
      margin-bottom: 10px;
      >li>button {
        padding: 5px 10px;
        margin-right: 10px;
        border-radius: 10px;
        transition: background 200ms;
        cursor: pointer;
        &:hover {
          color: $color-green !important
        }
        &.selected {
          background: $color-blue;
          color: white;
        }
      }
    }
    input {
      // font-size: 1.5em;
      margin-bottom: 5px
    }
    h4 {
      font-family: $font1 !important;
      font-weight: 700
    }
    // h4>select, h4>input {
    //   color: $color-blue;
    // }
    select {
      font-size: 1em;
      width: auto;
    }
  }
}
strong {
  color: $color-blue;
  padding: 10px 0 5px;
  display: inline-block;
}
.form-text {
  padding-left: 1em
}
.input-date {
  outline: 0;
  border: 0;
  border-bottom: 0.05rem solid #caced7;
}
.field {
  display: flex;
  width: 100%;
  justify-content: space-between;
  >* {
    margin: auto;
    &::after {
      content: ':'
    }
  }
}
.consultation-type {
  text-align: center;
  .btn {
    font-size: .7rem;
  }
}

.align-start {
  align-self: start;
}

.align-end {
  align-self: end;
}

.title {
  color: $dark-color;
  font-family: $font1;
  font-weight: bold;
}

.modal-body {
  box-sizing: border-box;
  padding: 0 2rem 2rem 2rem;
  gap: 10px;
}

.file-block {
  padding: 1rem;
  width: 100%;
  min-height: 8vh;
  border: 1px dashed #e5e5e5;
  display: flex;
  justify-content: center;
  align-items: center;
  .block {
    .icon-block {
      display: inline-block;
      .dr-icon {
        color: #494949;
        width: 20px;
      }
    }
    .text {
      color: #616161;
      font-size: 0.9em;
      font-weight: normal;
      padding: 0;
    }
    .file-list {
      list-style: none;
        .upload-file {
          font-size: 1em;
          font-weight: bold;
        }
    }
  }
}

.procedure {
  &__files {
    &-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      height: 50px;
      max-height: 50px;
    }

    &-item {
      cursor: pointer;
      flex-basis: 10%;
      height: 100%;
      margin-right: 10px;
      position: relative;

      & > div,
      & > div > figure {
        height: 90%;
        width: 90%;
      }

      &-container {
        height: 100%;
        margin: 0;
        // overflow: auto;
        padding: 0;
        width: 100%;

        img {
          display: block;
          margin: 0 auto;
        }
      }

      &--delete {
        align-items: center;
        background-color: #d8d8d8;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        height: 15px;
        justify-content: center;
        left: -5px;
        position: absolute;
        top: -5px;
        transition: all 0.2s ease;
        width: 15px;

        &:hover {
          background-color: #a2a2a2;
          transition: all 0.2s ease;
        }

        img {
          height: 7px;
          width: 7px;
        }
      }
    }
  }
}

.m-top-10 {
  margin-top: 10px;
}
</style>
<style lang="scss">
@import "$vars";
.editProcedure {
  overflow: auto;

  &__field {
    box-sizing: border-box;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    width: 100%;

    &:nth-of-type(2) {
      border-top: 1px solid $gray-color-light;
      border-bottom: 1px solid $gray-color-light;
      padding: 15px 0;
    }

    &:nth-of-type(3) {
      &-name {
        width: 100%;
      }
    }

    &-name, label {
      color: $gray-color-dark;
      font-size: 0.75rem;
      font-weight: 600;
      text-transform: none;
    }

    // &-value {}
  }
}
.w100 {
  box-sizing: border-box;
  width: 100%;
  > div {
    box-sizing: border-box;
    width: 100%;
  }
}
.w800px {
  box-sizing: border-box !important;
  margin: 0 auto !important;
  max-width: 1000px !important;
  padding: 0 !important;
  width: 1000px !important;
  height: 100%;
}

#pdf__container {
  display: flex;
  height: 100%;
  width: 100%;
}

.pdf-file {
  height: 100%;
  width: 100%;
}
</style>

<template>
  <form @submit.prevent="submit()" class="modal modal-md2 active" v-if="localActive" id="modal-id">
    <a @click="close()" class="modal-overlay" aria-label="Close"></a>
    <div class="modal-container" v-if="loaded">
      <div class="modal-header">
        <div class="close-block">
          <a @click="close()" class="btn btn-clear float-right" aria-label="Close"></a>
        </div>
      </div>
      <div class="d-flex flex-space_between flex-column modal-body editProcedure">
        <h4 class="title">{{ procedure.patientName }}</h4>

        <div class="editProcedure__field">
          <div class="editProcedure__field-name">
            Data de realização
          </div>
          <div class="editProcedure__field-value">
            {{ procedure.agendaAppointmentStart | TO_DATE_TIME }}
          </div>
        </div>

        <div class="editProcedure__field" v-if="procedure.status === 'REALIZADO'">
          <div class="editProcedure__field-name">
            Status
          </div>
          <div class="editProcedure__field-value">
            <span class="label label-performed">
              {{ procedure.status }}
            </span>
          </div>
        </div>
        <drField
          v-else
          v-model="formData.status"
          prefix="modalEditProcedure_"
          class="text-left margin-auto editProcedure__field"
          :id="'editProcedure_status'"
          :ref="'editProcedure_status'"
          :key="'editProcedure_status'"
          :form="formData"
          :field="formData.status"
        />

        <drField
          prefix="modalEditProcedure_"
          class="editProcedure__field w100"
          :id="'editProcedure_note'"
          :ref="'editProcedure_note'"
          :key="'editProcedure_note'"
          :field.sync="formData.diagnosticAnalysis"
          :form.sync="formData"
        />

        <div class="procedure__files-list" v-if="procedureFiles.length > 0">
          <div
            class="procedure__files-item"
            v-for="(file, index) in procedureFiles"
            v-bind:key="`procedureFile_${index}`">
            <span
              class="procedure__files-item--delete"
              @click="deleteProcedureFile(file.id)">
              <img v-bind:src="cross" class="dr-icon" />
            </span>

            <div
              @click="viewProcedureFile(file.imageName)"
              :ref="`fileIcon_procedure_${index}`"
            >
              <dr-icon
                name="file"
                class="dr-icon"
                color="#4cade4"
              />
            </div>
          </div>
        </div>

        <div class="procedure__file-upload">
          <FileUpload
            class="file-block"
            ref="upload"
            v-model="formData.file"
            :headers="$store.getters.getAuthHeader"
            :multiple="false"
            :drop="true"
            :drop-directory="false"
            :accept="accept"
            :extensions="extensions"
            @input-file="updateFile()"
            @blur="$v.formData.file.$touch()"
          >
            <div class="block">
              <div class="icon-block">
                <dr-icon name="upload" class="dr-icon" color="#616161"></dr-icon>
              </div>
              <p class="text">
                Arraste aqui arquivos de imagem nos formatos gif, jpg, ou png,
                com tamanho máximo de 3 MB, para enviar ao paciente.
              </p>
              <ul v-if="formData.file" class="file-list">
                <li v-for="file in formData.file" :key="file.id" class="upload-file">
                 <span>{{ file.name }}</span>
                </li>
              </ul>
            </div>
          </FileUpload>
        </div>

        <div class="d-flex flex-end m-top-10">
          <dr-submit class="align-end" :text="'Salvar alterações'" />
        </div>
      </div>
    </div>

    <!-- Modal de visualização de arquivo -->
    <div class="modal modal-lg" :class="fileModal ? 'active' : ''" id="modal-id" v-if="fileModal">
      <span class="modal-overlay" aria-label="Close" @click="fileModal = false"></span>
      <div class="modal-container w800px">
        <div class="modal-header">
          <span class="btn btn-clear float-right" aria-label="Close" @click="fileModal = false"></span>
        </div>
        <div class="modal-body w800px">
          <div class="content procedure__files-item-container">
            <template v-if="fileUrl.substr(-3) === 'pdf'">
              <div id="pdf__container" v-html="injectEmbed(fileUrl)"></div>
            </template>
            <img v-else :src="fileUrl">
          </div>
        </div>
        <div class="modal-footer">
          <span class="btn btn-primary" @click="fileModal = false">Fechar</span>
        </div>
      </div>
    </div>
    <!-- /Modal de visualização de arquivo -->
  </form>
</template>

<script>
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'
import FileUpload from 'vue-upload-component'
import cross from '@/assets/img/icons/ico_png/ico_cross.png'
import { maxLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
  props: ['active', 'doctor', 'procedure'],
  components: {
    drField,
    drSubmit,
    FileUpload
  },
  data () {
    return {
      loaded: true,
      localActive: null,
      patientName: '',
      sending: false,
      formData: {
        id: null,
        file: [],
        status: {
          size: 6,
          type: 'select',
          name: 'procedureStatus',
          required: false,
          placeholder: 'Escolha um status',
          label: 'Status',
          sending: false,
          value: '',
          options: [
            { id: 1, name: 'ABERTO' },
            { id: 2, name: 'REALIZADO' },
            { id: 3, name: 'CANCELADO PELO MÉDICO' },
            { id: 4, name: 'CANCELADO PELO PACIENTE' },
            { id: 5, name: 'NÃO COMPARECEU' }
          ]
        },
        diagnosticAnalysis: {
          size: 12,
          type: 'textarea',
          name: 'procedureNote',
          required: false,
          placeholder: 'Observações',
          sending: false,
          value: null
        }
      },
      // FileUpload
      files: [],
      cross: cross,
      fileModal: false,
      fileUrl: null,
      size: 3 * 1e+6,
      accept: 'image/png,image/gif,image/jpeg,application/pdf',
      extensions: ['jpg', 'jpeg', 'png', 'gif', 'png'],
      procedureFiles: []
    }
  },
  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    })
  },
  mounted () {
    this.localActive = false
  },
  watch: {
    'active' (next, prev) {
      this.localActive = next
      this.patientName = ''
      this.init()
      if (this.sending) {
        this.sending = false
      }
    },
    formData: {
      id (next, prev) {
        if (!!next !== !!null && this.procedureFiles.length === 0) {
          this.procedureFiles = []
          this.getProcedureFiles()
        }
      }
    }
  },
  validations: {
    formData: {
      diagnosticAnalysis: {
        maxLength: maxLength(500)
      }
    }
  },
  methods: {
    init () {
      this.loaded = true
      this.sending = false
      this.formData.status.value = this.formData.status.options.find(o => o.name === this.procedure.status).id
      this.formData.diagnosticAnalysis.value = this.procedure.diagnosticAnalysis
      this.formData.id = this.procedure.agendaId
      this.getProcedureFiles()
    },
    close () {
      this.localActive = false
      this.$emit('cancel', true)
    },
    getProcedureFiles () {
      this.fn_SHOW_PROGRESS()
      this.sending = true
      this.procedureFiles = []

      const url = `/${this.fn_IS_DOCTOR() ? 'doctor' : `secretary/doctor/${this.$route.params.doctorId}`}/doctor_office/${this.office.id}/agenda/${this.procedure.agendaId}/medical_procedure_file`
      const method = 'get'
      const headers = this.$store.getters.getAuthHeader.headers

      this.$http({ headers, method, url })
        .then((res) => {
          if (res.status === 200) {
            this.procedureFiles = []
            res.data.forEach(file => this.procedureFiles.push(file))
          }
        })
        .catch((err) => {
          console.log(`error:\n`, err)
        })
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.sending = false
        })
    },
    viewProcedureFile (src = null) {
      this.fileUrl = null
      this.fileModal = false

      if (src) {
        this.fileUrl = process.env.ROOT_API + '/' + process.env.DOCTOR_MEDICAL_PROCEDURE_FILE + src
        this.fileModal = true
      }
    },
    injectEmbed (file) {
      const embed = document.createElement('embed')
      embed.classList.add('pdf-file')
      embed.setAttribute('src', file)
      return embed.outerHTML
    },
    deleteProcedureFile (id = null) {
      if (id) {
        this.$store.dispatch('setModalConfirm', {
          title: 'Confirmação',
          body: `Tem certeza, que deseja remover o arquivo?<br><small>Esta ação não poderá ser revertida.</small>`,
          confirmText: 'Confirmar',
          cancelText: 'Cancelar',
          size: 'md',
          active: true,
          beforeClose: (v) => {
            if (!v) {
              this.$store.dispatch('setModalConfirm')
              return
            }

            const url = `/doctor/doctor_office/${this.office.id}/agenda/${this.procedure.agendaId}/medical_procedure_file/${id}`
            const headers = this.$store.getters.getAuthHeader.headers
            const method = 'delete'

            this.fn_SHOW_PROGRESS()

            this.$http({ url, headers, method })
              .then((res) => {
                if (res.status === 200) {
                  this.$store.dispatch('setModalAlert', {
                    title: 'Sucesso',
                    body: res.data,
                    size: 'md',
                    active: true
                  })
                }
              })
              .catch((err) => {
                console.log(`error\n`, err)
                this.$store.dispatch('setModalAlert', {
                  title: 'Erro',
                  body: 'Ocorreu um erro, tente novamente mais tarde',
                  size: 'md',
                  active: true
                })
              })
              .finally(() => {
                this.$store.dispatch('setModalConfirm')
                this.procedureFiles = []
                this.getProcedureFiles()
                this.fn_HIDE_PROGRESS()
              })
          }
        })
      }
    },
    submit () {
      this.sending = true
      this.fn_SHOW_PROGRESS()
      const rawData = this.fn_COPY_OBJECT(this.formData)
      const method = 'put'
      const url = `/doctor/doctor_office/${this.office.id}/agenda/${this.procedure.agendaId}/medical_procedure`
      const data = {
        diagnosticAnalysis: rawData.diagnosticAnalysis.value,
        status: (this.procedure.status === 'REALIZADO')
          ? this.procedure.status
          : ((rawData.status.value === '')
            ? this.procedure.status
            : rawData.status.options[rawData.status.value - 1].name)
      }
      this.$http({
        headers: this.$store.getters.getAuthHeader.headers,
        method,
        data: { update_medical_procedure: data },
        url
      })
        .then((res) => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Procedimento atualizado com sucesso',
            size: 'md',
            active: true
          })
          this.$emit('success')
          this.fn_HIDE_PROGRESS()
          this.localActive = false
        })
        .catch((err) => {
          console.log('error:', err)
          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: 'Ocorreu um erro.',
            size: 'md',
            active: true
          })
          this.fn_HIDE_PROGRESS()
          this.localActive = false
        })
    },
    updateFile (file, old) {
      if (!this.formData.id || !this.formData.file[0] || !this.formData.file[0].fileObject) {
        return
      }

      if (this.formData.file[0].size > 3 * 1e+6) {
        this.$store.dispatch('setModalAlert', {
          title: 'Ocorreu um erro',
          body: 'O tamanho máximo do arquivo é de 3 MB.',
          size: 'md',
          active: true
        })
        this.formData.file = []
        return
      }

      this.sending = true
      this.apiErrors = this.fn_BUILD_API_ERRORS(this.formData)

      const boundary = Math.random().toString().substr(2)
      const headers = this.fn_COPY_OBJECT(this.$store.getters.getAuthHeader)
      headers.headers['Content-Type'] = `multipart/form-data; charset=utf-8; boundary=${boundary}`

      const formData = new FormData()
      formData.append('medical_procedure_file[imageFile][file]', this.formData.file[0].file)

      this.fn_SHOW_PROGRESS()

      this.$http.post(`/doctor/doctor_office/${this.office.id}/agenda/${this.formData.id}/medical_procedure_file`, formData, headers)
        .then((res) => {
          let status = res.code || res.status
          if (status) {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'Arquivo enviado com sucesso!',
              size: 'md',
              active: true
            })

            this.formData.file = []
            this.getProcedureFiles()
          }
        })
        .catch(
          (err) => {
            console.log('error', err)
            this.fn_FLATTEN_OBJECT(err.errors.children).then(
              (res) => {
                for (let field in res) {
                  this.apiErrors[field.replace(/.children|.errors/g, '')] = res[field]
                }
              }
            )
            this.$store.dispatch('setModalAlert', {
              title: 'Erro',
              body: 'Ocorreu um erro, tente novamente mais tarde',
              size: 'md',
              active: true
            })
          }
        )
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.sending = false
        })
    }
  }
}
</script>
